/**
 * System Status page - Green/black theme, PublicPageLayout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../providers';
import { PublicPageLayout } from '../components/public';

const SystemStatus = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  const services = [
    { name: language === 'fr' ? 'API & Backend' : 'API & Backend', status: 'operational' },
    { name: language === 'fr' ? 'Paiements' : 'Payments', status: 'operational' },
    { name: language === 'fr' ? 'Application Web' : 'Web App', status: 'operational' },
    { name: language === 'fr' ? 'Notifications' : 'Notifications', status: 'operational' },
  ];

  return (
    <PublicPageLayout>
      <button type="button" onClick={() => navigate('/')} className="public-page-back">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
        {language === 'fr' ? "Retour à l'accueil" : 'Back to Home'}
      </button>

      <div className="public-page-hero">
        <h1 className="public-page-title">{language === 'fr' ? 'État du système' : 'System Status'}</h1>
        <p className="public-page-sub">
          {language === 'fr' ? 'Tous les systèmes sont opérationnels.' : 'All systems operational.'}
        </p>
      </div>

      <div className="public-page-section">
        <div className="public-page-card" style={{ marginBottom: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--pub-green)', boxShadow: '0 0 12px var(--pub-green-glow)' }} />
            <span style={{ fontWeight: 700, color: 'var(--pub-text)' }}>
              {language === 'fr' ? 'Tous les systèmes fonctionnent normalement' : 'All systems operational'}
            </span>
          </div>
          <p className="public-page-card-desc" style={{ marginBottom: 0 }}>
            {language === 'fr'
              ? 'Nos services sont disponibles. En cas d\'incident, nous publierons une mise à jour ici.'
              : 'Our services are available. We will post updates here if any issues occur.'}
          </p>
        </div>
        <div className="public-page-grid">
          {services.map((s, i) => (
            <div key={i} className="public-page-stat">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--pub-green)' }} />
                <span className="public-page-stat-num" style={{ fontSize: '1rem' }}>{s.name}</span>
              </div>
              <div className="public-page-stat-label" style={{ color: 'var(--pub-green)' }}>
                {s.status === 'operational' ? (language === 'fr' ? 'Opérationnel' : 'Operational') : s.status}
              </div>
            </div>
          ))}
        </div>
      </div>
    </PublicPageLayout>
  );
};

export default SystemStatus;
